import * as React from "react";
const SvgAvatarSubtract = () => /* @__PURE__ */ React.createElement("svg", { width: 160, height: 160, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M160 0H0v160h160zM80.2 80.633q8.647.129 15.748-4.389 7.1-4.517 11.23-12.261 4.26-7.744 4.26-17.425 0-9.164-4.26-16.779-4.13-7.615-11.23-12.132Q88.848 13 80.199 13t-15.748 4.647q-7.1 4.516-11.36 12.132t-4.26 16.78q0 14.455 9.165 24.264 9.165 9.681 22.203 9.81m-47.504 29.04q-4.503 4.727-7.696 9.41c12.715 16.477 32.651 27.096 55.069 27.117h.132c22.403-.021 42.329-10.627 55.045-27.087q-3.156-4.698-7.672-9.44-7.746-8.131-19.621-13.552-11.748-5.55-27.754-5.55t-27.882 5.55q-11.876 5.42-19.621 13.552",
    clipRule: "evenodd"
  }
));
export default SvgAvatarSubtract;
